import SellerBadgeList from './pages/SellerBadgeList.vue';
import NewSellerBadge from './pages/NewSellerBadge.vue';
import SellerBadgeListCard from './components/vendor/SellerBadgeListCard.vue';
import SaleOnlyHereComponent from './components/vendor/SaleOnlyHere.vue';
import BadgeDropDown from './components/BadgeDropDown.vue';

dokan_add_route(SellerBadgeList);
dokan_add_route(NewSellerBadge);

dokan.addFilterComponent('dokanSingleVendorSummarySectionStart', 'dokanVendor' , SellerBadgeListCard );
dokan.addFilterComponent('afterFeaturedCheckbox', 'dokanVendor' , SaleOnlyHereComponent );
dokan.addFilterComponent('dokanVendorFilterSectionStart', 'dokanVendor' , BadgeDropDown );

dokan.hooks.addFilter('DokanGetVendorArgs', 'dokanVendor' , (data, route) => {
    if(route.badge_id) {
        data.badge_id = route.badge_id;
    }

    return data;
}, 10, 2);
